// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___Nlpka","root__divide":"style-module__root__divide___qwqL4","root__divide_disabled":"style-module__root__divide_disabled___OzBwh"};
    if(module.hot) {
      // 1729151125724
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  